<template>
  <div class="select">
    <div class="title">
      <p>选择过程</p>
      <div class="line"></div>
    </div>
    <div class="tabs">
      <div class="tab-nav">
        <span
          :class="{ active: selected == 'product' }"
          @click="changeTabs('product')"
          >产品差异化</span
        >
        <p class="line">|</p>
        <span
          :class="{ active: selected == 'service' }"
          @click="changeTabs('service')"
          >服务差异化</span
        >
      </div>
    </div>
    <div class="tab-content">
      <div v-show="selected == 'product'">
        <div class="card">
          <div class="box">
            <img class="main" src="../../static/images/product/dunpai.png" />
            <div class="right">
              <h2>提高工作效率与精准度</h2>
              <div class="delegation">
                <img src="../../static/images/product/sibianxing.png" />
                <p>提高工作效率与精准度</p>
              </div>
              <div class="delegation">
                <img src="../../static/images/product/sibianxing.png" />
                <p>减少大量手工验证工作，提升审计效率</p>
              </div>
              <div class="delegation">
                <img src="../../static/images/product/sibianxing.png" />

                <p>降低损失发生的可能性，提高管理效率</p>
              </div>
              <div class="delegation">
                <img src="../../static/images/product/sibianxing.png" />

                <p>协助审计方法的统一、共享与传承</p>
              </div>
            </div>
          </div>
          <div class="box">
            <img class="main" src="../../static/images/product/cube.png" />
            <div class="right">
              <h2>提高风险把控度，异常警示减少出错</h2>
              <div class="delegation">
                <img src="../../static/images/product/sibianxing.png" />
                <p>建立有效的舞弊风险防范机制，提升舞弊管控水平</p>
              </div>
              <div class="delegation">
                <img src="../../static/images/product/sibianxing.png" />
                <p>实时识别异常事项，提早预判风险</p>
              </div>
              <div class="delegation">
                <img src="../../static/images/product/sibianxing.png" />
                <p>通过IDM身份管理平台配置应用/服务的访问权限，保证访问安全</p>
              </div>
              <div class="delegation">
                <img src="../../static/images/product/sibianxing.png" />
                <p>及时解决内控缺陷及风险敞口，优化管理措施</p>
              </div>
              <div class="delegation">
                <img src="../../static/images/product/sibianxing.png" />
                <p>
                  有效预防及尽早发现舞弊事件的警号，大程度降低舞弊事件给企业带来的损失
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="practice">
          <h2>产品用户体验高</h2>
          <div class="water">
            <div class="block frist">
              <img src="../../static/images/product/1.png" />
              <h2>简单易用</h2>
              <p>七大功能产品，<br />构建地产营销新生态</p>
            </div>
            <div class="block two">
              <img src="../../static/images/product/2.png" />
              <h2>创新型开发</h2>
              <p>
                基于房企客户生命全周期打造<br />首个互动式营销、服务平台构建地产营销新生态
              </p>
            </div>
            <div class="block three">
              <img src="../../static/images/product/3.png" />
              <h2>高质量</h2>
              <p>
                重塑房企与客户
                <br />之间的连接
              </p>
            </div>
            <div class="block four">
              <img src="../../static/images/product/4.png" />
              <h2>资源整合</h2>
              <p>灵活的O2O模式，让营销模<br />式工具引入管理功能</p>
            </div>
            <div class="block five">
              <img src="../../static/images/product/5.png" />
              <h2>高覆盖面</h2>
              <p>挖掘大数据时代的房 <br />地产营销新机遇</p>
            </div>
            <div class="block six">
              <img src="../../static/images/product/6.png" />
              <h2>畅快体验</h2>
              <p>
                打通线上线下体验，快速 <br />
                实现小投入、大产出
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-show="selected == 'service'">
        <div class="implement">
          <h2>售后实施：培训安装、退款条款</h2>
          <p>轻流程咨询：从体验设计规划到执行 布署的一站式客户体验咨询服务</p>
          <div class="img-box">
            <div class="train">
              <img src="../../static/images/product/service.png" />
              <div class="talk">您好，有什么为你服务？</div>
              <div class="version">
                <p class="title">电话维护服务</p>
                <div class="line"></div>
                <p class="desc">
                  专业服务工程师为您提供及时的咨询诊断及解决建议
                </p>
              </div>
            </div>
            <div>
              <img src="../../static/images/product/content.png" />
            </div>
          </div>
          <h2>售后服务</h2>
        </div>

        <div class="after-sale">
          <div class="sale-top">
            <div class="item">
              <img src="../../static/images/product/top_one.png" />
              <span>专业</span>
              <p>给予企业信息化全生命周期的一站式服务</p>
            </div>
            <div class="item">
              <img src="../../static/images/product/top_two.png" />
              <span>智能</span>
              <p>智能云服务平台</p>
            </div>
            <div class="item">
              <img src="../../static/images/product/top_three.png" />
              <span>创新</span>
              <p>创新“云+端”服务支持模式</p>
            </div>
          </div>
          <div class="sale-middle">
            <div class="item" v-for="item in serviceList" :key="item.id" @mouseenter="enterMiddle(item.id)" @mouseleave="leaveMiddle">
              <img v-if="enterId == item.id" :src="item.activeImg" />
              <img v-else :src="item.img" />
              <span>{{item.title}}</span>
              <div class="ul" >
                <div class="li" v-for="(s_item,s_index) in item.descArr" :key="s_index">{{s_item}}</div>
              </div>
            </div>
  
          </div>
          <div class="sale-bottom">
            <div class="item">
              <img src="../../static/images/product/bottom_top.png" />
              <div class="title">产品支持服务</div>
              <div class="main">
                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>
                    安全稳定：故障排除与修复、智能体检、智能监控、产品补丁包
                  </p>
                </div>

                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>持续可用：产品智能在线服务、云ERP开放平台版本升级包</p>
                </div>
              </div>
            </div>
            <div class="item">
              <img src="../../static/images/product/bottom_top.png" />
              <div class="title">应用支持服务</div>
              <div class="main">
                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>系统操作咨询服务</p>
                </div>

                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>系统代操作服务</p>
                </div>
                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>用户培训服务</p>
                </div>
                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>数据价值输出服务</p>
                </div>
                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>主动巡检与诊断服务</p>
                </div>
                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>个性化知识库维护</p>
                </div>
              </div>
            </div>
            <div class="item">
              <img src="../../static/images/product/bottom_top.png" />
              <div class="title">技术类增值服务</div>
              <p class="desc">专家运维团队帮助地产客户强化信息化建设</p>
              <div class="main">
                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>性能压力负载测试服务</p>
                </div>

                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>系统上云服务</p>
                </div>
                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>云托管代运维服务</p>
                </div>
                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>人工服务时间定制</p>
                </div>
                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>服务器环境迁移服务</p>
                </div>
                <div class="delegation">
                  <img src="../../static/images/product/sibianxing.png" />
                  <p>云ERP开发平台生态服务</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selected: "product",
      enterId: -1,
      serviceList: [
        {
          id: 0,
          img: require("../../static/images/product/middle_one.png"),
          activeImg: require("../../static/images/product/one_active.png"),
          title: "高级支持服务",
          descArr: ["现场支持", "数据处理"],
        },
        {
          id: 1,
          img: require("../../static/images/product/middle_two.png"),
          activeImg: require("../../static/images/product/two_active.png"),
          title: "标准支持服务",
          descArr: [
            "版本升级",
            "版本更新",
            "版本更新",
            "在线问答",
            "知识库",
            "在线课程",
            "故障诊断",
            "应用指导",
            "服务预约",
            "系统监控",
            "应用评估",
            "服务工具",
          ],
        },
        {
          id: 2,
          img: require("../../static/images/product/middle_three.png"),
          activeImg: require("../../static/images/product/three_active.png"),
          title: "免费服务",
          descArr: ["免费服务工具", "注册管理",'应用评估服务','公开技术文档','一匠云之家','用户论坛','在线公开课程','Newsletter订阅'],
        },
        {
          id: 3,
          img: require("../../static/images/product/middle_four.png"),
          activeImg: require("../../static/images/product/four_active.png"),
          title: "专属服务",
          descArr: ["VIP专线坐席", "VIP绿色通道",'顾问驻点'],
        },
        {
          id: 4,
          img: require("../../static/images/product/middle_five.png"),
          activeImg: require("../../static/images/product/five_active.png"),
          title: "专享服务",
          descArr: ["升级/迁移服务", "性能优化服务",'应用评估服务','系统巡检服务','系统巡检服务','功能增强服务','IT 代维服务','IT 运维服务'],
        },
        {
          id: 5,
          img: require("../../static/images/product/middle_six.png"),
          activeImg: require("../../static/images/product/six_active.png"),
          title: "云运维服务",
          descArr: ["云巡检", "云审计",'云迁移','云课堂'],
        },
      ],
    };
  },
  methods: {
    changeTabs(type) {
      this.selected = type;
    },
    enterMiddle(id){
      this.enterId = id;
    },
    leaveMiddle(){
      this.enterId = -1;
    }
    
  },
};
</script>
<style lang="stylus" scoped>
.select {
  width: 100%;
  background: #fff;
  margin-top: 90px;

  .title {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;

    p {
      font-size: 30px;
      font-weight: bold;
      color: #333333;
    }

    .line {
      width: 42px;
      height: 2px;
      background: #FFC000;
      border-radius: 1px;
      margin-top: 29px;
    }
  }

  .tabs {
    display: flex;
    justify-content: center;
    margin-top: 90px;

    .tab-nav {
      display: flex;
      width: 288px;
      justify-content: center;
      border-bottom: 1px solid #E1E6F0;
    }

    span {
      color: #333333;
      font-size: 16px;
      font-weight: 500;
      color: #56627E;
      display: inline-block;
      width: 144px;
      text-align: center;
      cursor: pointer;
    }

    span.active {
      color: #EDB50C;
      border-bottom: 2px solid #EDB50C;
      padding-bottom: 20px;
    }

    .line {
      color: #EBF0FC;
    }
  }

  .tab-content {
    margin-top: 46px;

    .card {
      display: flex;
      justify-content: center;
      align-items: center;

      .box:hover {
        box-shadow: 1px 4px 13px 0px rgba(175, 175, 175, 0.16);
      }

      .box {
        display: flex;
        width: 730px;
        height: 343px;
        background: #FFFFFF;
        padding: 77px 6px 0 65px;
        box-sizing: border-box;
        transition: all 0.4s;

        img.main {
          min-width: 152px;
          height: 152px;
        }

        .delegation {
          display: flex;
          align-items: flex-start;
        }

        img {
          width: 7px;
          height: 6px;
        }

        .right {
          margin-left: 59px;

          h2 {
            font-size: 22px;
            font-weight: bold;
            color: #343434;
            margin-bottom: 29px;
          }

          p {
            display: inline-block;
            font-size: 14px;
            font-weight: 500;
            color: #666666;
            margin-left: 8px;
            margin-bottom: 14px;
          }
        }
      }
    }

    .practice {
      text-align: center;
      margin-top: 108px;
      padding-bottom: 176px;

      h2 {
        font-size: 22px;
        font-weight: bold;
        color: #343434;
        line-height: 28px;
      }

      .water {
        position: relative;
        margin-top: 108px;
        background: url('../../static/images/product/water.png');
        background-repeat: no-repeat;
        height: 224px;
        background-position: 50% 50%;

        .block {
          position: absolute;

          h2 {
            margin-top: 25px;
            font-size: 18px;
            font-weight: bold;
            color: #343434;
          }

          p {
            margin-top: 8px;
            font-size: 16px;
            font-weight: 500;
            color: #666666;
            line-height: 20px;
          }
        }

        .frist {
          left: 200px;
          top: -20px;
        }

        .two {
          left: 340px;
          top: 70px;
        }

        .three {
          left: 680px;
          top: -40px;
        }

        .four {
          left: 880px;
          top: 70px;
        }

        .five {
          left: 1120px;
          top: 40px;
        }

        .six {
          left: 1350px;
          top: -20px;
        }
      }
    }
  }

  .implement {
    padding: 28px 0 58px;

    h2 {
      text-align: center;
      font-size: 22px;
      font-weight: 800;
      color: #333333;
    }

    p {
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #666666;
      margin-top: 20px;
    }

    .img-box {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 56px;

      .train {
        position: relative;
        margin-right: 106px;

        .talk {
          position: absolute;
          top: 180px;
          left: 340px;
          font-size: 12px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 63px;
          text-shadow: 0px 2px 9px rgba(237, 181, 11, 0.18);
        }

        .version {
          width: 100%;
          position: absolute;
          bottom: 150px;

          .title {
            font-size: 20px;
            font-weight: 800;
            color: #333333;
          }

          .line {
            width: 30px;
            height: 2px;
            background: #FFC000;
            border-radius: 1px;
            margin: 19px auto;
          }

          .desc {
            font-size: 16px;
            font-weight: 500;
            color: #666666;
            margin-top: 37px;
          }
        }
      }
    }
  }

  .after-sale {
    padding: 92px 0 239px;
    width: 100%;
    background-color: #FAFAFA;

    .sale-top {
      display: flex;
      justify-content: center;
      align-items: center;

      .item {
        width: 479px;
        height: 171px;
        background: #FFFFFF;
        box-sizing: border-box;
        padding: 43px 0 0 49px;
        margin-right: 12px;

        span {
          font-size: 22px;
          font-weight: 800;
          color: #333333;
          padding-left: 14px;
        }

        p {
          font-size: 16px;
          font-weight: 500;
          color: #999999;
          padding: 8px 0 0 60px;
        }
      }
    }

    .sale-middle {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      align-items: center;
      padding: 92px 0 98px;

      .item:hover {
        background-color: #fff;
      }

      .item {
        box-sizing: border-box;
        width: 490px;
        height: 185px;
        padding: 28px 0 18px 69px;
        transition: all 0.4s;

        span {
          font-size: 16px;
          font-weight: 800;
          color: #333333;
          margin-left: 8px;
        }

        .ul {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          font-size: 14px;
          font-weight: 500;
          color: #666666;
          padding: 17px 0 0 35px;

          .li {
            width: 33%;
            margin-bottom: 15px;
          }
        }
      }
    }

    .sale-bottom {
      display: flex;
      justify-content: center;
      align-items: center;

      .item {
        position: relative;
        width: 416px;
        height: 418px;
        background: #FFFFFF;
        margin-right: 49px;

        .title {
          position: absolute;
          top: 40px;
          left: 46px;
          font-size: 18px;
          font-weight: 800;
          color: #333333;
        }

        .desc {
          position: absolute;
          top: 72px;
          left: 46px;
          font-size: 14px;
          font-weight: 500;
          color: #666666;
        }

        .main {
          margin: 44px 49px 0 47px;

          .delegation {
            display: flex;
            align-items: flex-start;
            margin-bottom: 28px;
          }

          p {
            font-size: 14px;
            font-weight: 500;
            color: #666666;
            line-height: 20px;
            margin-left: 8px;
          }

          img {
            width: 7px;
            height: 6px;
            margin-top: 8px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/ProductSelect.vue